import { FormikErrors } from "formik";
import { DocumentsInformation, FinancialInfoContainer, PersonalInfoContainer, RequestInfoContainer} from "../..";
import { ReferenceDocument } from "../ReferenceDocument/ReferenceDocument";

interface RenderContainerProps {
    errors?: FormikErrors<{}>
    values?: any;
    setValues?: (values: any) => void;
    step: 'credit_information' | 'person_information' | 'finance_information' | 'reference_information';
    setPopup: React.Dispatch<React.SetStateAction<string>>;
}

export function RenderContainer(props: RenderContainerProps) {
    const {step, errors, values, setValues, setPopup} = props;
    const renderOption = () => {
        switch (step) {
            case 'credit_information':
                return <RequestInfoContainer errors={errors} values={values}/>
            case 'person_information':
                return <PersonalInfoContainer errors={errors} values={values} setValues={setValues} setPopup={setPopup}/>
            case 'finance_information':
                return <FinancialInfoContainer errors={errors} values={values}/>
            case 'reference_information':
                return <ReferenceDocument  errors={errors} values={values}/>
        }
    };
    return (
        <div>{renderOption()}</div>
    )
}